import * as moment from "moment";
import { CurrentValidations, StatusTask } from "../../../interfaces/task.interface";
import { FormControl, FormGroup } from "@angular/forms";
import { modeTypeWithDuplicate } from "src/app/shared/interfaces/inputype.interface";
import { configurations, GroupOption } from "src/app/shared/interfaces/configurations.interface";
import { localDB } from "src/app/shared/helpers/localStorage";
import { updateValidationsHelper } from "../../../helpers/functions";

export function buildCurrentValidations(
  aAllTareoStatus: StatusTask[],
  nTotal_Minutos_Recuperar: number = 0
): CurrentValidations {
  const today = moment().format("YYYY-MM-DD");
  const todayStatus = aAllTareoStatus.find((x) => x.dDate === today);

  return {
    sEstado: todayStatus?.sEstado ?? "FALTA",
    sEstado_Horario: todayStatus?.sEstado_Horario ?? "HORARIO_REGULAR",
    nRequired: todayStatus?.nRequired ?? 0,
    nReady: todayStatus?.nReady ?? 0,
    entrada: todayStatus?.entrada ?? "09:00:00",
    salida: todayStatus?.salida ?? "18:00:00",
    dHora_Inicio: todayStatus?.dHora_Inicio ?? "00:00:00",
    dHora_Fin: todayStatus?.dHora_Fin ?? "00:00:00",
    nMinutos_Permiso: todayStatus?.nMinutos_Permiso ?? 0,
    dDate: today,
    nMaxMinutesRegular: todayStatus?.nMaxMinutesRegular ?? 0,
    nMaxMinutesRegularEditar: todayStatus?.nMaxMinutesRegularEditar ?? 0,
    nMaxMinutesExtra: todayStatus?.nMaxMinutesExtra ?? 0,
    nMaxMinutesExtraEditar: todayStatus?.nMaxMinutesExtraEditar ?? 0,
    nTotal_Minutos_Recuperar,
    nId_Colaborador: todayStatus?.nId_Colaborador ?? 0,
    nEntryMark: todayStatus?.nEntryMark ?? 0,
  };
}

export function initMinutes(
  taskForm: FormGroup,
  mode: string,
  aAllTareoStatus: StatusTask[],
  currentValidations: CurrentValidations,
  updateMaxMinutes: (tipoHora: string) => void,
  setCurrentValidations: (validations: CurrentValidations) => void,
  setIsSinAsistencia: (val: boolean) => void
) {
  if (mode === "create") {
    taskForm.get("nMinutos")!.patchValue(60);
    taskForm.get("sCodigo_Tipo_Horas")?.patchValue("1");
  }

  taskForm.get("nMinutos")!.valueChanges.subscribe((value) => {
    const nHours = Math.round((value / 60) * 100) / 100;
    taskForm.get("nCantidad")!.patchValue(nHours);
  });

  taskForm.get("dFecha_Registro")!.valueChanges.subscribe((value) => {
    const found = aAllTareoStatus.find(
      (x) => x.dDate === moment(value).format("YYYY-MM-DD")
    );

    const newValidations = found
      ? found
      : {
        ...currentValidations,
        sEstado_Horario: "SIN_ASISTENCIA",
        dDate: taskForm.get("dFecha_Registro")!.value.format("YYYY-MM-DD"),
      };

    setCurrentValidations(newValidations);
    setIsSinAsistencia(newValidations.sEstado_Horario === "SIN_ASISTENCIA");

    if (taskForm.get("sCodigo_Tipo_Horas")!.valid) {
      updateMaxMinutes(taskForm.get("sCodigo_Tipo_Horas")!.value);
    }
  });
}

export function getMaxMinutes(
  tipo_Hora: string,
  mode: modeTypeWithDuplicate,
  currentValidations: CurrentValidations,
  taskForm?: FormGroup
): number {
  if (!currentValidations) return 480;
  let maxMinutes = 480;
  switch (tipo_Hora) {
    case "1": // HORARIO_REGULAR
      switch (mode) {
        case "create":
          maxMinutes = currentValidations.nMaxMinutesRegular || 0;
          break;
        case "update":
          maxMinutes = currentValidations.nMaxMinutesRegularEditar || 0;
          break;
        case "duplicate":
          maxMinutes = currentValidations.nMaxMinutesRegular || 0;
          break;
        default:
          maxMinutes = currentValidations.nMaxMinutesRegular || 0;
          break;
      }
      break;
    case "5":
      const currentMinutes = taskForm?.get("nMinutos")?.value ?? 0;
      const totalRecuperar = currentValidations.nTotal_Minutos_Recuperar || 0;
      if (mode === "update") {
        maxMinutes = totalRecuperar + currentMinutes;
        maxMinutes = maxMinutes < 0 ? 0 : maxMinutes;
      } else {
        maxMinutes = totalRecuperar < 0 ? 0 : totalRecuperar;
      }
      break;
    default: // EXTRAS, COMPENSACIÓN, AVANCE
      switch (mode) {
        case "create":
          maxMinutes = currentValidations.nMaxMinutesExtra || 0;
          break;
        case "update":
          maxMinutes = currentValidations.nMaxMinutesExtraEditar || 0;
          break;
        case "duplicate":
          maxMinutes = currentValidations.nMaxMinutesExtra || 0;
          break;
        default:
          maxMinutes = currentValidations.nMaxMinutesExtra || 0;
          break;
      }
      break;
  }
  if (mode === 'create' || mode === 'duplicate') {
    const today = moment().format('YYYY-MM-DD');
    const selectedDate = taskForm?.get('dFecha_Registro')?.value;
    if (selectedDate && moment(selectedDate).format('YYYY-MM-DD') === today) {
      return applyTodayIntervalValidation(maxMinutes, taskForm);
    }
  }
  return maxMinutes;
}

function applyTodayIntervalValidation(maxMinutes: number, taskForm?: FormGroup): number {
  const today = moment().format('YYYY-MM-DD');
  const selectedDate = taskForm?.get('dFecha_Registro')?.value;
  if (!selectedDate || moment(selectedDate).format('YYYY-MM-DD') !== today) {
    return maxMinutes;
  }
  const intervals = JSON.parse(localDB.getItem('Intervals') || '{}');
  const aIntervals = intervals.aIntervals || [];
  const modalOpenTime = moment(localDB.getItem('modalOpenTime') || moment().toISOString());
  const nineAM = moment().set({ hour: 9, minute: 0, second: 0, millisecond: 0 });
  let currentMaxMinutes = 480;
  let totalUnregisteredMinutes = 0;
  const todayIntervals = aIntervals.filter((interval: any) => {
    const intervalDate = moment(interval.dDate).format('YYYY-MM-DD');
    return intervalDate === today;
  });
  const intervalCodes = [...new Set(todayIntervals.map((interval: any) => interval.nInterval))];
  intervalCodes.forEach((intervalCode: any) => {
    const intervalCodeNumber = Number(intervalCode);
    if (isNaN(intervalCodeNumber)) return;
    const intervalMarks = todayIntervals.filter((interval: any) => interval.nInterval === intervalCodeNumber);
    const entryMarks = intervalMarks.filter((mark: any) => mark.nType_Mark === 1);
    const exitMarks = intervalMarks.filter((mark: any) => mark.nType_Mark === 2);
    entryMarks.forEach((entryMark: any, index: number) => {
      const entryTime = moment(entryMark.dDate);
      const adjustedEntryTime = entryTime.isBefore(nineAM) ? nineAM : entryTime;
      const correspondingExit = exitMarks[index];
      if (correspondingExit) {
        const exitTime = moment(correspondingExit.dDate);
        const intervalMinutes = exitTime.diff(adjustedEntryTime, 'minutes');
        if (intervalMinutes > 0) {
          totalUnregisteredMinutes += intervalMinutes;
        }
      } else {
        const minutesFromEntry = modalOpenTime.diff(adjustedEntryTime, 'minutes');
        if (minutesFromEntry > 0 && minutesFromEntry < currentMaxMinutes) {
          currentMaxMinutes = minutesFromEntry;
        }
      }
    });
  });
  const finalMaxMinutes = Math.min(currentMaxMinutes + totalUnregisteredMinutes, 480);
  return Math.min(finalMaxMinutes, maxMinutes);
}

export function updateValidationsForTodayHelper(fecha: moment.Moment, nMinutos: number, task: any, data: any, executed = false): void {
  if (executed) return;
  const taskDate = fecha.format("YYYY-MM-DD");
  const tareoStatus = data.aAllTareoStatus || data.configurations?.aAllTareoStatus || [];
  const currentStatus = tareoStatus.find((status: any) => status.dDate === taskDate);
  if (!currentStatus) return;
  const minutosActuales = currentStatus.nMaxMinutesRegular ?? 0;
  const nuevoMaximo = Math.max(minutosActuales - nMinutos, 0);
  currentStatus.nMaxMinutesRegular = nuevoMaximo;
  currentStatus.nMaxMinutesExtra = nuevoMaximo;
  currentStatus.nMaxMinutesRegularEditar = nuevoMaximo;
  currentStatus.nMaxMinutesExtraEditar = nuevoMaximo;
  if (task.sCodigo_Tipo_Horas === "5") {
    currentStatus.nTotal_Minutos_Recuperar = Math.max(0, currentStatus.nTotal_Minutos_Recuperar - nMinutos);
  }
  localDB.setItem('calculatedMaxMinutes', nuevoMaximo.toString());
}

export function initCodeProjectHelper(
  taskForm: FormGroup,
  tipoActividad: configurations[],
  proyectosColaborador: configurations[],
  proyectosConAcceso: configurations[]
): GroupOption[] {
  const optionsGroups: GroupOption[] = [];
  tipoActividad.forEach((x: configurations) => {
    let group: GroupOption | null = null;
    switch (x.sCodigo) {
      case "1":
        group = {
          groupValue: "1",
          groupName: "Mis Proyectos",
          groupOptions: proyectosColaborador,
        };
        break;
      case "2":
      case "3":
        group = {
          groupValue: x.sCodigo,
          groupName: "Todos",
          groupOptions: proyectosConAcceso,
        };
        break;
    }
    if (group) optionsGroups.push(group);
  });
  const indexMisProyectos = optionsGroups.findIndex((item) => item.groupValue === "1");
  if (indexMisProyectos > -1) {
    optionsGroups.unshift(optionsGroups.splice(indexMisProyectos, 1)[0]);
  }
  taskForm.get("sCodigo_Proyecto")!.patchValue(null);
  return optionsGroups;
}

export function addExtraFields(taskForm: FormGroup) {
  taskForm.addControl('dHora_Inicio', new FormControl(null));
  taskForm.addControl('dHora_Fin', new FormControl(null));
  taskForm.addControl('dFecha_Fin', new FormControl(null));

  taskForm.get('nMinutos')?.valueChanges.subscribe((value) => {
    const horaInicioCtrl = taskForm.get('dHora_Inicio');
    if (!horaInicioCtrl) return;

    if (!value) {
      horaInicioCtrl.disable();
    } else if (horaInicioCtrl.value) {
      horaInicioCtrl.enable();
    }
  });

  taskForm.get('dHora_Inicio')?.valueChanges.subscribe((value) => {
    if (value) {
      const dateOfStartActivity = taskForm.get('dFecha_Registro')?.value;
      const durationMinutes = taskForm.get('nMinutos')?.value ?? 0;

      const { Time, Date } = calculateEndHour(value, dateOfStartActivity, durationMinutes);

      taskForm.get('dHora_Fin')?.patchValue(Time);
      taskForm.get('dFecha_Fin')?.patchValue(Date);
    }
  });

  taskForm.get('dFecha_Registro')?.valueChanges.subscribe((value) => {
    const horaInicio = taskForm.get('dHora_Inicio')?.value;
    if (value && horaInicio) {
      const durationMinutes = taskForm.get('nMinutos')?.value ?? 0;

      const { Time, Date } = calculateEndHour(horaInicio, value, durationMinutes);

      taskForm.get('dHora_Fin')?.patchValue(Time);
      taskForm.get('dFecha_Fin')?.patchValue(Date);
      taskForm.get('dHora_Inicio')?.updateValueAndValidity();
    }
  });
}

export function calculateEndHour(
  inputTime: string,
  dateOfStartActivity: moment.Moment,
  durationMinutes: number
): { Time: string; Date: string } {
  const [hours, minutes = "0"] = inputTime.split(":");

  const startDateTime = moment(dateOfStartActivity).set({
    hour: parseInt(hours, 10),
    minute: parseInt(minutes, 10),
    second: 0,
  });

  const endDateTime = startDateTime.clone().add(durationMinutes, "minutes");

  return {
    Time: endDateTime.format("HH:mm"),
    Date: endDateTime.format("YYYY-MM-DD"),
  };
}

/*Filtrar requerimientos por proyectos*/
export function findProjectInfo(optionsGroups: GroupOption[], value: string) {
  for (let group of optionsGroups) {
    const option = group.groupOptions.find((opt) => opt.sCodigo === value);
    if (option) {
      return { activityType: group.groupValue, project: option.sDescripcion };
    }
  }
  return null;
}

export function getRequirementFromActivityEdit(
  activityEdit: any,
  projectValue: string,
  requerimientos: configurations[]
) {
  if (activityEdit && activityEdit.sCodigo_Proyecto === projectValue) {
    return requerimientos.find(
      (x: configurations) => x.sCodigo === activityEdit.sCodigo_Requerimiento
    );
  }
  return null;
}

export function getCategoryInitial(
  categorias: configurations[],
  lastItemSelected: string | null,
  activityEdit: any,
  requerimientoValue: string
) {
  if (!categorias.length) return null;
  if (lastItemSelected) {
    const categoria = categorias.find((x) => x.sCodigo === lastItemSelected);
    if (categoria) {
      return categoria;
    }
  }
  if (activityEdit && activityEdit.sCodigo_Requerimiento === requerimientoValue) {
    const categoria = categorias.find((x) => x.sCodigo === activityEdit.sCodigo_Categoria);
    if (categoria) {
      return categoria;
    }
  }
  return categorias[0];
}

export function findCategoryByCode(
  categorias: configurations[],
  codigo: string
) {
  return categorias.find((x) => x.sCodigo === codigo) ?? null;
}